export default __webpack_public_path__ + "static/5-d0722854dd5661ae4f1c3cb0eef60600.jpg";